import {useEffect, useState} from 'react';
import Tabs from "rc-tabs";
import TabPane from "rc-tabs/lib/TabPanelList/TabPane";

import Field from "../../../workflow/Field";
import Alert from "../../../alert/Alert";
import Loading from "../../../generic/Loading";
import {EmailLabel, InfoLabel, SettingsLabel} from "../../../../config/Config";
import { UseRequest } from "../../../../hooks/UseRequest";


const Email = (props) => {
    const {journey, currentNode} = props

    const [loading, setLoading] = useState(false)
    const [emails, setEmails] = useState([])


    const Information = {
        className: 'alert-primary',
        message  : `This component allows you to send an email campaign. `,
        docs     : {
            message: 'For more information, please ',
            path   : '/docs/journeys/email/'
        }
    }

    const Id = {
        tab         : 'info',
        name        : 'id',
        type        : 'text',
        label       : 'Component Id',
        wrapper     : 'form-group',
        disabled    : true,
        canCopy     : true,
        defaultValue: currentNode.id,
        node        : currentNode,
    }

    const Title = {
        tab         : 'info',
        name        : 'title',
        type        : 'text',
        label       : 'Title',
        wrapper     : 'form-group',
        placeholder : 'Type an descriptive title',
        node        : currentNode,
        defaultValue: EmailLabel,
    }


    const Description = {
        tab        : 'info',
        name       : 'description',
        type       : 'textarea',
        label      : 'Description',
        wrapper    : 'form-group',
        className  : 'form-control',
        placeholder: 'Type a short description',
        node       : currentNode,
    }


    const ChooseEmail = {
        tab            : 'settings',
        name           : 'id_email',
        type           : 'select',
        label          : 'Choose an email',
        wrapper        : 'form-group',
        className      : 'input-sm',
        classNamePrefix: 'input-sm',
        placeholder    : 'Choose an email',
        required       : true,
        isMulti        : false,
        isSearchable   : true,
        options        : emails,
        node           : currentNode
    }


    const fetchEntities = async () => {
        const askForEmails = UseRequest(
            `${process.env.REACT_APP_BASE_API}/emails/get`, {
                request: {
                    method: 'PUT', data: {
                        offset: 0, id_enterprise: journey.Audience.Enterprise._id.$oid
                    }
                }
            }
        );

        const output = {emails: []};
        const data = await (await askForEmails).json();
        if(data && data.entities && data.entities.length > 0){
            data.entities.map((entity) => {
                output.emails.push({value: entity._id.$oid, label: entity.content.subject})
            })
        }

        return output
    }


    useEffect(() => {
        setLoading(true)
        fetchEntities().then((response) => {
            setEmails(response.emails)
            setLoading(false)
        })
    }, [])


    return (
        <div>
            {loading && <Loading/>}
            {!loading && <div className="Form">
                <form className="FormComponent">
                    <div className="max-width-500">
                        <Alert {...Information} />

                        <div className="FieldsetTabs">
                            <Tabs defaultActiveKey="0">
                                <TabPane forceRender={true} key={'tab_settings'} tabKey={'tab_settings'} tab={SettingsLabel}>
                                    <div>
                                        <Field {...ChooseEmail} />
                                    </div>
                                </TabPane>
                                <TabPane forceRender={true} key={'tab_info'} tabKey={'tab_info'} tab={InfoLabel}>
                                    <div>
                                        <Field {...Id}/>
                                        <Field {...Title}/>
                                        <Field {...Description}/>
                                    </div>
                                </TabPane>
                            </Tabs>
                        </div>
                    </div>
                </form>
            </div>}
        </div>
    )
}

export default Email;